var _excluded = ["className", "disabled", "fullWidth", "link", "iconLeft", "iconRight", "label", "secondary", "shouldRender", "primary", "destructive", "outline", "upperCase", "ariaHasPopUp", "ariaExpanded", "onClick", "onMouseEnter", "onMouseLeave", "omitDefaultStyles"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Button INSTEAD.
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';
var Button = function Button(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    link = _ref.link,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    label = _ref.label,
    secondary = _ref.secondary,
    shouldRender = _ref.shouldRender,
    primary = _ref.primary,
    destructive = _ref.destructive,
    outline = _ref.outline,
    upperCase = _ref.upperCase,
    ariaHasPopUp = _ref.ariaHasPopUp,
    ariaExpanded = _ref.ariaExpanded,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    omitDefaultStyles = _ref.omitDefaultStyles,
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonRef = useRef(null);
  var handleClick = function handleClick(e) {
    if (disabled) {
      e.preventDefault();
    } else {
      onClick(e);
      buttonRef.current.blur();
    }
  };
  var buttonClass = classNames('inline-block font-regular-font focus:shadow-button py-2 px-4 rounded border border-solid',
  // Base classes
  {
    // Conditional classes
    'text-sm font-medium focus:border-focus-blue capitalize': !omitDefaultStyles,
    'bg-action-blue text-white border-transparent': primary && !omitDefaultStyles,
    'hover:bg-deep-blue': primary && !omitDefaultStyles && !disabled,
    'bg-white text-brand-blue border-light-border-blue': secondary && !omitDefaultStyles,
    'hover:bg-medium-fill-grey': secondary && !omitDefaultStyles && !disabled,
    'bg-transparent text-action-blue border-medium-border-blue': outline && !omitDefaultStyles,
    'hover:border-action-blue hover:text-deep-blue': outline && !omitDefaultStyles && !disabled,
    'bg-white border-button text-black': !primary && !secondary && !outline && !link && !omitDefaultStyles,
    'border-none bg-transparent text-action-blue p-4': link,
    'bg-red text-white border-transparent': !primary && !secondary && !outline && destructive && !omitDefaultStyles,
    'hover:bg-dark-red': !primary && !secondary && !outline && destructive && !disabled && !omitDefaultStyles,
    'opacity-40 cursor-default': disabled,
    'cursor-pointer': !disabled,
    'w-full': fullWidth,
    uppercase: upperCase,
    'flex items-center justify-center': iconLeft || iconRight
  }, className // User-defined classes
  );
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: buttonRef,
    className: buttonClass,
    "aria-haspopup": ariaHasPopUp,
    "aria-label": label,
    onClick: handleClick,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter,
    "aria-disabled": disabled,
    "aria-expanded": ariaExpanded
  }, rest), iconLeft && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'inherit'
    },
    className: "inline-block mr-2 transform -translate-y-px"
  }, iconLeft), label, iconRight && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'inherit'
    },
    className: "inline-block ml-2 transform -translate-y-px"
  }, iconRight));
};
Button.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** label text for button */
  label: PropTypes.string,
  /**
   * Gets called when the user clicks(tap) on the button
   *
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  /** value to determine button styles and configs Primary */
  primary: PropTypes.bool,
  /** value to determine button styles and configs */
  secondary: PropTypes.bool,
  /** value to determine button styles and configs */
  destructive: PropTypes.bool,
  /** value to determine button styles and configs */
  outline: PropTypes.bool,
  /**
   * If true, the button will be disabled.
   *
   */
  disabled: PropTypes.bool,
  /**
   * If true, the button will be full width.
   *
   */
  fullWidth: PropTypes.bool,
  /**
   * If true, the button will be a link.
   *
   */
  link: PropTypes.bool,
  /** Conditional logic to determine if render || default value: true */
  shouldRender: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Apply types on the button component i.e. "submit", "reset", "button", etc */
  type: PropTypes.string,
  /** Icon node element displayed on the left of the label */
  iconLeft: PropTypes.node,
  /** Icon node element displayed on the right of the label */
  iconRight: PropTypes.node,
  /** text style for button if wanting to uppercase */
  upperCase: PropTypes.bool,
  /** standardized attr for selectors */
  'data-test-element': PropTypes.string,
  /** standardized attr for selectors */
  'data-testid': PropTypes.string,
  /** indicates type of interactive popup element that can be triggered. One of: menu, listbox, tree, grid, dialog, or true */
  ariaHasPopUp: PropTypes.string,
  /** indicates whether the element, or another grouping element it controls, is currently expanded or collapsed */
  ariaExpanded: PropTypes.bool,
  /** omit default styles */
  omitDefaultStyles: PropTypes.bool
};
Button.defaultProps = {
  id: '',
  className: '',
  label: '',
  link: false,
  onClick: noop,
  onMouseEnter: noop,
  onMouseLeave: noop,
  primary: false,
  secondary: false,
  destructive: false,
  outline: false,
  disabled: false,
  fullWidth: false,
  shouldRender: true,
  style: {},
  type: 'button',
  iconLeft: null,
  iconRight: null,
  'data-test-element': null,
  'data-testid': null,
  upperCase: false,
  ariaHasPopUp: undefined,
  omitDefaultStyles: false,
  ariaExpanded: false
};
export default Button;